import { inject as service } from '@ember/service';
import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
import { PricingType } from '@square/dashboard-items-data/models/item-variation';
import { isNone, isPresent } from '@ember/utils';
import { WeightUnit } from '../models/item-variation';
import { MEASUREMENT_UNIT_MAX_PRECISION, SERVICE_COST_PERCENTAGE_PRECISION } from '@square/dashboard-data/models/catalog/catalog-service-constants';
export default ItemsV3Serializer.extend({
  attrs: {
    itemOptionValues: {
      serialize: 'ids',
      deserialize: 'ids'
    }
  },
  measurementUnits: service(),
  normalize(type, object) {
    if (!isNone(object.weight_amount)) {
      object.weight_amount = object.weight_amount / Math.pow(10, MEASUREMENT_UNIT_MAX_PRECISION);
    }

    // If the service cost percentage is set, normalize it to the correct precision.
    // The normalized value is needed by the UI to display the correct value between 0 and 100.
    if (!isNone(object.service_cost_percentage)) {
      object.service_cost_percentage = object.service_cost_percentage / Math.pow(10, SERVICE_COST_PERCENTAGE_PRECISION);
    }

    // TODO: Ember data does not overwrite keys when they are missing from the response
    object.measurement_unit_id = object.measurement_unit_id ?? null;
    return this._super(type, object);
  },
  serialize(snapshot) {
    const json = this._super(snapshot, {
      includeId: true
    });
    const pricingType = snapshot.record.isVariablePriced ? PricingType.VARIABLE_PRICING : PricingType.FIXED_PRICING;
    json.pricing_type = PricingType.serialize(pricingType);
    if (isPresent(json.weight_amount)) {
      json.weight_amount = Math.round(json.weight_amount * Math.pow(10, MEASUREMENT_UNIT_MAX_PRECISION));

      // If the weight amount is set, ensure that the weight unit is also set
      if (isNone(json.weight_unit)) {
        const weightUnit = this.measurementUnits.defaultItemWeightUnit;
        json.weight_unit = WeightUnit.serialize(weightUnit);
      }
    }

    // If the service cost percentage is set, denormalize it to the correct precision.
    // The denormalized value is needed by the server to determine the correct value
    // for commissions.
    if (isPresent(json.service_cost_percentage)) {
      json.service_cost_percentage = Math.round(json.service_cost_percentage * Math.pow(10, SERVICE_COST_PERCENTAGE_PRECISION));
    }

    // If the option value relationship has not been loaded then we will round trip
    // the original option ids. If this relationship has been loaded then we override
    // the option ids array with the ids of the updated values array.
    const itemOptionValuesRelationship = snapshot.record.hasMany('itemOptionValues');
    if (itemOptionValuesRelationship.value()) {
      json.item_option_ids = itemOptionValuesRelationship.value().mapBy('itemOptionId');
    }
    return json;
  }
});